






























































import { computed, defineComponent, ref } from "@vue/composition-api";
import { InputAiUserQuestionaryUpdate } from "@scrile/api-provider/dist/projects/scrileConnect/AiUserQuestionaryProvider";
import { $t } from "@/lib/i18nHelpers";
import { QuickTip } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseForm from "@/components/BaseForm";
import BaseStepper from "@/components/BaseStepper";
import PageTitle from "@/components/PageTitle";
import QuickTipsItem from "@/components/QuickTipsItem";
import { fields } from "../../config";

export default defineComponent({
  name: "AiQuestionaryOnboarding",
  components: { QuickTipsItem, BaseForm, BaseStepper, BaseButton, BaseIcon, BaseConfirm, PageTitle },
  props: {
    nsfwEnabled: { type: Boolean, required: true },
  },
  setup(props, { emit }) {
    const showStartModel = ref(true);
    const showCompleteModel = ref(false);
    const processing = ref(false);
    const values = ref<InputAiUserQuestionaryUpdate["fields"]>({});
    const showTipItem = ref(true);
    const valid = ref(false);
    const availableFields = computed(() => {
      if (!props.nsfwEnabled) {
        const { nsfw, ...rest } = fields;
        return rest;
      }
      return fields;
    });

    const stepsCount = computed(() => Object.keys(availableFields.value).length);
    const tipItem = computed<QuickTip>(() => {
      return {
        icon: "msr-info",
        translateKey: $t("AI_questionary_tip"),
      };
    });

    const getCurrentFields = (currentStep: number) => {
      if (currentStep > 0 && currentStep <= Object.keys(availableFields.value).length) {
        return availableFields.value[Object.keys(availableFields.value)[currentStep - 1]];
      } else return [];
    };

    const onSave = () => {
      processing.value = true;
      emit("save", values.value, () => {
        processing.value = false;
        showCompleteModel.value = true;
      });
    };

    return {
      availableFields,
      showStartModel,
      showCompleteModel,
      values,
      stepsCount,
      processing,
      tipItem,
      showTipItem,
      valid,
      getCurrentFields,
      onSave,
    };
  },
});
